import { ApiError, NetworkError } from '@/lib/api-error'

/**
 * Текст ошибки для нового визуального слоя.
 *
 * Отдельно от `lib/problem-message.ts`, потому что тот требует `TFunction` и
 * собирает сообщения через i18n. Новый слой русскоязычный, а главное — API уже
 * присылает человеческий `detail` по-русски (`application/problem+json`,
 * док 06 §1). Дублировать эти строки на клиенте значит гарантированно их
 * разойтись: сервер поменяет формулировку, а панель будет показывать старую.
 *
 * Поэтому правило простое: показываем `detail` сервера, а свои формулировки
 * держим только для случаев, когда ответа нет вообще.
 */
export function errorText(error: unknown): string {
  if (error instanceof NetworkError) {
    return 'Нет связи с сервером. Проверьте интернет и попробуйте снова.'
  }
  if (error instanceof ApiError) {
    const detail = error.problem.detail
    if (typeof detail === 'string' && detail !== '') return detail
    if (error.status === 403) return 'Недостаточно прав для этого действия.'
    if (error.status === 404) return 'Объект не найден — возможно, он уже удалён.'
    if (error.status >= 500) return 'Сервер ответил ошибкой. Мы записали её в лог.'
    return 'Запрос не прошёл.'
  }
  if (error instanceof Error && error.message !== '') return error.message
  return 'Что-то пошло не так.'
}
